// Element英文样式
import enLocale from 'view-design/dist/locale/en-US';
const en = {
  "CompanyProfile": "Company Profile",
  "CompanyName": "公司名称（中文）",
  "ExhibitorRegistration": "Exhibitor registration",
  // 计划投放广告
  "OnlineAd": "Online Ad",
  "Livestream": "Livestream",
  "ShowCatalogue": "Show Catalogue",
  "VisitorTicket": "Visitor Ticket",
  "VisitorBag": "Visitor Bag",
  "BanneratEntryHall": "Banner at Entry Hall",
  "OthersPleaseOpecify": "Others, please specify ",
  "WhichAd": "Which would you prefer for your ad. plan if you have",
  "PleaseTickYourExhibits": "Please tick your exhibits",
  "SpaceType": "Space Type",
  "Quantity": "Quantity",
  "YourExhibitionPlan": "Your exhibition plan",
  "SubmitSpaceApplication": "Submit space application",


  "Homepage": "Homepage",
  "YourProgress": "Your Progress",
  "SpaceConstruction": "Space Construction",
  "BadgeApplication": "Badge Application",
  "ExhibitorManual": "Exhibitor Manual",
  "RawSpaceConstruction": "Raw Space Construction",
  "SYMA": "SYMA",

  "FacialBoard": "Facial Board (Shell Scheme)",
  "ExhibitorBadge": "Exhibitor Badge",
  "VisitorBadge": "Visitor Badge",
  "VehiclePass": "Vehicle Pass",
  "Important": "Important",
  "Contact": "Contact",
  "WelcometoBakeryChina2022": "Welcome to Bakery China 2022",
  "Countdown": "Countdown",
  "YourRreparationProgress": "Your Rreparation Progress",
  "View": "View",
  "tobecompleted": "to be completed",
  "YourAccount": "Your Account",
  "Changeyourphonenumber": "Change your phone number",
  "Changeyouremail": "Change your email",
  "Changeyourpassword": "Change your password",
  "CompanyCentre": "Company Centre",

  ...enLocale
}


export default en
